import React, { Component } from 'react';
import { connect } from 'react-redux';
import {
    Spin, Table, Card, Input, Icon, Modal,
} from 'antd';
import { columns } from '../statics';
import { debounce } from '../../../../shared/helpers';
import { getAffiliatesRequest } from '../redux/actions/get_affiliates.actions';
import AffiliateUpdate from '../../Manage_affiliates_update/components/AffiliateUpdate';

const mapStateToProps = (state) => {
    const {
        loading, affiliates, where, pagination, amount,
    } = state.PlatformManagement.Manage_affiliates;
    return {
        loading, affiliates, where, pagination, amount,
    };
};

export default connect(mapStateToProps, null)(class AffiliateList extends Component {
  state = {
      visible: false,
  };

  componentDidMount() {
      this.getAffiliatesWithFilters();
  }

  getAffiliatesWithFilters = (where, pagination) => this.props.dispatch(getAffiliatesRequest({ ...this.props.where, ...where }, pagination));

  handleChangePage = (page, pageSize) => this.getAffiliatesWithFilters(this.props.where, { page, pageSize });

  searchByAffiliateName = ({ target: { value } }) => {
      this.getAffiliatesWithFilters({
          name: {
              $regex: value,
              $options: 'mi',
          },
          old_crm_affiliate_id: this.props.where.old_crm_affiliate_id || undefined,
      }, this.props.pagination);
  };

  searchByOldCrmAffiliateID = ({ target: { value } }) => {
      this.getAffiliatesWithFilters({
          name: this.props.where.name || undefined,
          old_crm_affiliate_id: value || undefined,
      }, this.props.pagination);
  };

  debouncedGetLeadRequest = debounce(this.getAffiliatesWithFilters, 500);

  resetData = () => this.props.dispatch({ type: 'RESET_AFFILIATE_DATA_WITH_FILTERS' });

  showModalForUpdateData = (affiliate) => {
      this.setState({ visible: true });
      this.props.dispatch({ type: 'SET_CURRENT_AFFILIATE', payload: affiliate });
  };

  handleCancel = () => this.setState({ visible: false });

  render() {
      return (
          <Spin spinning={this.props.loading} tip="Get affiliates ...">
              <Card className="border-shadows">
                  <Input
                      placeholder="Search by affiliate name"
                      style={{ width: '20%', marginBottom: 20 }}
                      onChange={this.searchByAffiliateName}
                      allowClear
                      value={this.props.where.name && this.props.where.name.$regex}
                  />
                  <Input
                      type="number"
                      placeholder="Search by old crm affiliate id"
                      style={{ width: '20%', marginBottom: 20, marginLeft: 15 }}
                      onChange={this.searchByOldCrmAffiliateID}
                      allowClear
                      value={this.props.where.old_crm_affiliate_id}
                  />
                  <Icon
                      type="sync"
                      onClick={this.resetData}
                      style={{ float: 'right', paddingTop: 10 }}
                  />
                  <Table
                      rowKey="_id"
                      style={{ paddingTop: -55 }}
                      columns={columns}
                      dataSource={this.props.affiliates}
                      onRow={record => ({
                          onClick: (event) => {
                              if (event.target.tagName !== 'TD') {
                                  this.showModalForUpdateData(record);
                              }
                          },
                      })}
                      pagination={{
                          total: this.props.amount,
                          showSizeChanger: true,
                          showQuickJumper: true,
                          current: this.props.pagination.page,
                          pageSize: this.props.pagination.pageSize,
                          pageSizeOptions: ['10', '25', '50', '100'],
                          onChange: this.handleChangePage,
                          onShowSizeChange: this.handleChangePage,
                      }}
                  />
              </Card>
              <Modal
                  visible={this.state.visible}
                  footer={null}
                  onCancel={this.handleCancel}
              >
                  <AffiliateUpdate />
              </Modal>
          </Spin>
      );
  }
});



// WEBPACK FOOTER //
// ./src/modules/PlatformManagement/Manage_affiliates/components/AffiliateList.js